import React, { useEffect, useState } from 'react';
import history from '~/services/history';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import OneSignal from 'react-onesignal';
import { Header } from '~/components/Header';
import { MobileFooter } from '~/components/MobileFooter';
import Footer from '~/components/Footer/Footer';
import * as ActionsLayout from '~/store/modules/layout/actions';
import ReactGA from 'react-ga4';
import routes from '../../routes';
import BackgroundLucree from '../../assets/img/backgroundLucrEE.png';



export default function ClientLayout() {
	const { user } = useSelector((state) => state.auth);
	const layout = useSelector((state) => state.layout);
	const dispatch = useDispatch();
	const [notificacoes, setNotificacoes] = useState([]);
	const [dataNotification, setDataNotification] = useState([]);
	const [sidebar, setSidebar] = useState({ active: false });
	const [isMobile, setIsMobile] = useState(false);
	useEffect(() => {
		OneSignal.init({
			appId: "9465934f-241d-49db-abfb-cef3fc550bb9",
		});
	}, []);


	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768);
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);


	useEffect(() => {
		if (user.dados == null) {
			history.push('/auth/login');
		}

		if (user?.dados && window.innerWidth >= 768) {
			// Widget Track
			(function (f, b, g) {
				const dados = {
					name: user?.dados?.nome,
					email: user?.dados?.email,
					telefone: user?.dados?.telefone,
					user_id: `${user?.dados?.user_id}`,
					cidade_uf: user?.dados?.estado,
					cnpj_cpf: user?.dados?.documento,
					grupo_negocio: user?.dados?.cargo,
					negocio: user?.dados?.tipo_projeto,
				};

				Object.keys(dados).forEach(key => {
				if (!dados[key]) delete dados[key];
				});

				var a = {
					key: 'CvmKwtcx',
					customer: dados,
					appendTo: 'id-do-elemento-html',
				};
				var e;
				var c = f.getElementsByTagName(b)[0];
				if (f.getElementById(g)) { return };
				e = f.createElement(b);
				e.id = g;
				e.src = 'https://app.track.co/widget.min.js';
				e.type = 'text/javascript';
				e.async = true;
				e.onload = e.onreadystatechange = function () {
					/* eslint-disable */
				var h = this.readyState;
				if (h && h !== 'complete' && h !== 'loaded') { return };
				try {
					var c = new TrackWidget();
					c.createWidget(a);
				} catch (i) {
					console.log("ERROR trackwidget: ", i)
				}
				};
				c.parentNode.insertBefore(e, c);
			})(document, 'script', 'trackwidget-js');
		}
	}, [user, isMobile]);

	useEffect(() => {
		dispatch(ActionsLayout.setLayout('client'));
		eventGACargoUser();
	}, [dispatch]);

	// (function (f, b, g) {
	// 	var a = {
	// 		key: "c6078698ef5f3f6f",
	// 		campaign: "eb94815d",
	// 		name: user.dados.nome || '',
	// 		email: user.dados.email || '',
	// 		telefone: user.dados.telefone || '',
	// 		negocio: user.dados.tipo_projeto || '',
	// 		cnpjcpf: user.dados.documento || '',
	// 		tags: {
	// 			"pgm": user.dados.cargo || '',
	// 			"perfil": user.dados.tipo_perfil || '',
	// 			"name": user.dados.nome || '',
	// 			"email": user.dados.email || '',
	// 			"telefone": user.dados.telefone || '',
	// 			"negocio": user.dados.tipo_projeto || '',
	// 			"identification": user.dados.user_id || '',
	// 			"cnpjcpf": user.dados.documento || '',
	// 			"uf": user.dados.estado || '',
	// 			"nome": user.dados.nome || ''
	// 		},
	// 		// salute: "%name.first%, tudo bem?",
	// 		// thanks: "Obrigado, %name.first%!"
	// 	};
	// 	var e;
	// 	var c = f.getElementsByTagName(b)[0];
	// 	if (f.getElementById(g)) { return }
	// 	e = f.createElement(b);
	// 	e.id = g;
	// 	e.src = "https://cdn.tracksale.co/tracksale-js/tracksale.js";
	// 	e.type = "text/javascript";
	// 	e.async = true;
	// 	e.onload = e.onreadystatechange = function () {
	// 		var h = e.readyState;
	// 		if (h && h !== "complete" && h !== "loaded") { return }
	// 		try {
	// 			/* eslint-disable no-undef */
	// 			var d = new Tracksale();
	// 			d.init(a)
	// 		} catch (i) {
	// 			console.log(i)
	// 		}
	// 	};
	// 	c.parentNode.insertBefore(e, c)
	// }(document, "script", "tracksale-js"));



	// (function (f, b, g) {
	// 	var a = {
	// 		key: 'CvmKz6vK',
	// 		customer: {
	// 			name: user.dados.nome,
	// 			user_id: user.dados.user_id,
	// 		}
	// 	};
	// 	var e;
	// 	var c = f.getElementsByTagName(b)[0];
	// 	if (f.getElementById(g)) {
	// 		return;
	// 	}
	// 	e = f.createElement(b);
	// 	e.id = g;
	// 	e.src = "https://cdn.tracksale.co/tracksale-js/tracksale.js";
	// 	e.type = "text/javascript";
	// 	e.async = true;
	// 	e.onload = e.onreadystatechange = function () {
	// 		var h = e.readyState;
	// 		if (h && h !== "complete" && h !== "loaded") {
	// 			return
	// 		} try {
	// 			/* eslint-disable no-undef */
	// 			var d = new Tracksale();
	// 			d.init(a)
	// 		} catch (i) {
	// 			console.log(i)
	// 		}
	// 	};
	// 	c.parentNode.insertBefore(e, c);
	// }(document, "script", "tracksale-js"));

	function getRoutes(rotas) {
		return rotas.map((prop) => {
			if (prop.layout === '/client') {
				return (
					<Route
						path={`${prop.layout}${prop.path}`}
						component={prop.component}
						key={prop.name}
					/>
				);
			}
			return null;
		});
	}

	if (!user.signed) {
		return <Redirect to="/auth/login" />;
	}

	function eventGACargoUser() {
		(user.dados && user.dados.tipo_cliente !== 'split' && user.dados.cargo.toLowerCase() === '') && (
			ReactGA.event({
				category: "revenda_nao_pgm",
				action: "Acesso Revenda não PGM",
				label: "Acesso com usuário Revenda não PGM",
			})
		)

		user.dados && user.dados.tipo_cliente === 'split' && (
			ReactGA.event({
				category: "pgm_tipo",
				action: `Tipo PGM: ${user.dados.tipo_projeto}`,
				label: `Acesso com usuário PGM do tipo ${user.dados.tipo_projeto}`,
			})
		)

		switch (user.dados && user.dados.cargo.toLowerCase()) {
			case '':
				return ReactGA.event({
					category: "revenda_click",
					action: "Acesso Revenda",
					label: "Acesso com usuário Revenda",
				});
			case 'distribuidor - matriz':
				return ReactGA.event({
					category: "distribuidor_matriz_click",
					action: "Acesso Distribuidor Matriz",
					label: "Acesso com usuário Distribuidor Matriz",
				});
			case 'distribuidor - filial':
				return ReactGA.event({
					category: "distribuidor_filial_click",
					action: "Acesso Distribuidor Filial",
					label: "Acesso com usuário Distribuidor Filial",
				});
			case 'distribuidor - filial - vendedor':
				return ReactGA.event({
					category: "distribuidor_filial_vendedor_click",
					action: "Acesso Distribuidor Filial Vendedor",
					label: "Acesso com usuário Distribuidor Filial Vendedor",
				});
			case 'distribuidor - matriz - vendedor':
				return ReactGA.event({
					category: "distribuidor_matriz_vendedor_click",
					action: "Acesso Distribuidor Matriz Vendedor",
					label: "Acesso com usuário Distribuidor Matriz Vendedor",
				});
			case 'distribuidor - matriz - comprador':
				return ReactGA.event({
					category: "distribuidor_matriz_comprador_click",
					action: "Acesso Distribuidor Matriz Comprador",
					label: "Acesso com usuário Distribuidor Matriz Comprador",
				});
			case 'industria':
				return ReactGA.event({
					category: "industria_click",
					action: "Acesso Industria",
					label: "Acesso com usuário Industria",
				});
			default:
				return 'null';
		}
	}

	if (!user) {
		return null;
	}

	return (
		<div className={`wrapper ${sidebar.active ? 'wrapper-sidebar-open' : 'wrapper-sidebar-closed'}`}>
			<Header
				user={user}
				layout={layout.tipo}
				sidebar={sidebar}
				setSidebar={setSidebar}
				setNotificacoes={setNotificacoes}
				notificacoes={notificacoes}
				dataNotification={dataNotification}
				setDataNotification={setDataNotification}
				/>

			<div
				className="main-panel"
				style={{
					width: '100%',
					backgroundColor: '#D3FBE1',
					backgroundImage: `linear-gradient(to bottom, rgba(211, 251, 225, 0.7), rgba(211, 251, 225, 0.7)), url(${BackgroundLucree})`,
					backgroundSize: 'cover',
				}}>
				<div className="route-painel" style={{ minHeight: 'calc(100vh - 166px)' }}>
					<Switch>{getRoutes(routes)}</Switch>
				</div>
				{isMobile &&
					<MobileFooter
						layout={layout.tipo}
						notificacoes={notificacoes}
						dataNotification={dataNotification}
					 />
				}
				<Footer fluid />
			</div>
		</div>
	);
}
